import type { ComponentType } from "react";
import { Suspense, lazy, useEffect, useState } from "react";

type FactoryType<T> = () => Promise<{ default: T }>;

export function lazyLoadComponentFactory<TProps>(factory: FactoryType<ComponentType<TProps>>) {
    const LazyComponent = lazy(factory) as ComponentType<TProps>;

    const FragmentWrapper = (props: TProps) => {
        const [isClient, setIsClient] = useState<boolean>(false);

        useEffect(() => setIsClient(true), []);

        return <Suspense>{isClient && <LazyComponent {...props} />}</Suspense>;
    };

    return FragmentWrapper;
}
